import { useNavigate } from "react-router-dom";

export default function BrandVoiceIndicator({ brandProfile, userEmail, getSnarkLabel }) {
  const navigate = useNavigate();

  if (brandProfile && userEmail) {
    return (
      <div className="mb-6 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-gray-900 mb-1 flex items-center gap-2">
              ✨ Brand Settings Active
            </h3>

            <div className="text-xs text-gray-600 space-y-1">
              {brandProfile.voice_name && (
                <p>• Active Voice: {brandProfile.voice_name}</p>
              )}

              {brandProfile.snark_level !== undefined && (
                <p>• Snark Level: {getSnarkLabel(brandProfile.snark_level)}</p>
              )}
            </div>
          </div>

          <button
            onClick={() => navigate("/settings")}
            className="text-xs text-sabre-blue hover:text-sabre-blue/80 font-medium"
          >
            Edit Settings
          </button>
        </div>
      </div>
    );
  }

  if (!brandProfile && userEmail && userEmail.includes("@")) {
    return (
      <div className="mb-6 bg-gray-50 border border-gray-200 rounded-lg p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-gray-900 mb-1">
              💡 Tip: Set up your brand voice
            </h3>
            <p className="text-xs text-gray-600">
              Define your brand&apos;s personality once and get more consistent content every time.
            </p>
          </div>

          <button
            onClick={() => navigate("/settings")}
            className="text-xs bg-sabre-blue text-white px-3 py-1.5 rounded hover:bg-sabre-blue/90 font-medium whitespace-nowrap"
          >
            Go to Settings
          </button>
        </div>
      </div>
    );
  }

  return null;
}